// Fuente única de verdad para la URL base de la API.
// Todos los componentes importan desde aquí, nunca desde App.js,
// eliminando el ciclo: App.js → Component → App.js.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
